var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass:
        "tw-w-full tw-flex tw-items-center tw-bg-footy-red tw-text-white tw-px-3 tw-fixed tw-z-50 breadcrumb-bar-container"
    },
    [
      _c(
        "span",
        { staticClass: "tw-mr-1 tw-capitalize tw-text-sm tw-md:tw-text-base" },
        [_vm._v(_vm._s(_vm.breadcrumb.root))]
      ),
      _c("span", { staticClass: "tw-mr-1 tw-text-sm tw-md:tw-text-base" }, [
        _vm._v("/")
      ]),
      _c(
        "div",
        {
          staticClass:
            "tw-mr-1 tw-font-semibold tw-capitalize tw-text-sm tw-md:tw-text-base tw-overflow-hidden"
        },
        [
          _c("span", { staticClass: "tw-whitespace-no-wrap" }, [
            _vm._v(" " + _vm._s(_vm.breadcrumb.path) + " ")
          ])
        ]
      ),
      _c("v-spacer"),
      _c("v-progress-circular", {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.loading,
            expression: "loading"
          }
        ],
        staticClass: "tw-mx-3",
        attrs: { size: 25, width: 3, color: "white", indeterminate: "" }
      }),
      !_vm.mobile
        ? _c(
            "v-icon",
            {
              staticClass: "tw-mx-3",
              attrs: { color: "#fff" },
              on: { click: _vm.openAnotherTab }
            },
            [_vm._v("mdi-monitor-multiple")]
          )
        : _vm._e(),
      _vm.currentUser && !_vm.mobile
        ? _c("span", { staticClass: "tw-mx-3" }, [
            _c("strong", [
              _vm._v(
                " " +
                  _vm._s(_vm.currentUser.first_name) +
                  " " +
                  _vm._s(_vm.currentUser.last_name) +
                  " "
              )
            ])
          ])
        : _vm._e(),
      _c(
        "v-btn",
        {
          staticClass: "ml-3",
          attrs: { small: "", color: "secondary" },
          on: { click: _vm.signOut }
        },
        [_vm._v("Log Out")]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }